import React from "react";
import { Text } from "@react-pdf/renderer";

export const renderMultilingualText = (text = "", styles = {}) => {
  const regex = /([\u3400-\u9FBF]+)/g;

  const parts = text.split(regex);

  return (
    <Text>
      {parts.map((part, index) => {
        const isChinese = /[\u3400-\u9FBF]/.test(part);

        const style = isChinese ? [styles.fontChinese, styles.textXs] : [styles.fontThai, styles.textMs];
        return (
          <Text key={index} style={style}>
            {part}
          </Text>
        );
      })}
    </Text>
  );
};
